import {
  ICategorizedResponse,
  IResult,
  ILocationQueryLabel,
  LocationQueryEnum,
} from "redmond";
import queryStringParser from "query-string";
import { fetchLocationAutocomplete } from "../../../api/v0/search/fetchLocationAutocomplete";

export const getLocationNameToResolve = (params: {
  search: string;
  existingLocation: IResult | null;
}): string | null => {
  const { search, existingLocation } = params;

  // Availability already resolved and set location this session — don't clobber it.
  if (existingLocation) return null;

  const { locationName } = queryStringParser.parse(search);
  return typeof locationName === "string" ? locationName : null;
};

// Same matching semantics as the availability saga's fetchLocation: prefer an
// exact label match, otherwise take the first autocomplete result.
export const findMatchingLocation = (
  categories: ICategorizedResponse[],
  label: string,
): IResult | null => {
  const allResults = categories.flatMap((category) => category.results);
  const exactMatch = allResults.find(
    (result) => result.label.toLowerCase() === label.toLowerCase(),
  );
  return exactMatch ?? allResults[0] ?? null;
};

export const fetchLocationForBookPage = async (
  locationName: string,
): Promise<IResult | null> => {
  const label = decodeURIComponent(locationName);
  const requestBody: ILocationQueryLabel = {
    LocationQuery: LocationQueryEnum.Label,
    l: label,
  };
  const { categories } = await fetchLocationAutocomplete(requestBody);
  return findMatchingLocation(categories, label);
};
